import React from 'react';

const Input = (props) => (
  <div className="">
    <input className="form-control"
      disabled={false || props.disabled}
      name={props.name}
      type={props.type}
      value={props.value}
      onChange={e => props.controlFunc(e)}
      placeholder="&nbsp;"
      maxLength={props.maxLength}
    />
    <label>{props.label} {(props.imp === "true") && <span className="text-danger">*</span>}</label>
    <div className="help-block">{props.error}</div>
  </div>
);

export default Input;
